import React from "react";
import { Target, Eye } from "lucide-react";
import { motion } from "framer-motion";

const MissionVision = () => {
  return (
    <section className="section-padding bg-card">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {[
            {
              icon: Target,
              title: "Our Mission",
              paragraphs: [
                "To provide exceptional transport and logistics services to the mining industry, ensuring safe, reliable, and efficient delivery of mining commodities while maintaining the highest standards of customer service.",
                "We are committed to supporting the growth of the mining sector by offering specialized transport solutions that meet the unique challenges of moving valuable mining commodities across Southern Africa.",
              ],
            },
            {
              icon: Eye,
              title: "Our Vision",
              paragraphs: [
                "To be the leading transport partner for the mining industry in Southern Africa, recognized for our reliability, safety record, and commitment to excellence in all aspects of our operations.",
                "We envision expanding our footprint across the region while maintaining our core values of integrity, professionalism, and customer focus.",
              ],
            },
          ].map((item, i) => (
            <motion.div
              key={i}
              className="bg-accent p-8 rounded-2xl border border-border hover:shadow-lg transition-all duration-300"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.12 }}
            >
              <div className="flex items-center mb-6 gap-4">
                <div className="w-12 h-12 rounded-xl bg-primary flex items-center justify-center">
                  <item.icon size={22} className="text-primary-foreground" />
                </div>
                <h2 className="text-2xl font-bold text-foreground">{item.title}</h2>
              </div>
              {item.paragraphs.map((p, j) => (
                <p key={j} className="text-muted-foreground leading-relaxed mb-4 last:mb-0 text-sm">
                  {p}
                </p>
              ))}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MissionVision;
